import styled from "styled-components";
import useUserProgram from "../../hooks/profile/useUserProgram";
import ProgramItem from "./ProgramItem";

function UserProgram(){
    const {programList} = useUserProgram();

    if(!programList.length){
        return null;
    }

    const renderProgramList = () => {
        if(programList.length){
            return programList.map((item, index) => {
                const totalAmount = item.class.amount + item.option_list.reduce((sum, item) => sum + item.amount, 0);
                return <ProgramItem
                    key={item.id} 
                    id={item.id}
                    thumbnailImg={item.thumbnail_img}
                    title={item.title}
                    classData={item.class}
                    optionList={item.option_list}
                    totalAmount={totalAmount}
                />
            })
        }
        return null;
    }

    return(
        <Container>
            <Title>PROGRAM</Title>
            <Content>
                <HorizontalSprator />
                {renderProgramList()}
                <HorizontalSprator />
            </Content>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30px;
    gap: 20px;
    border-radius: 20px;
    background-color: #EBEBEB;
`

const Title = styled.div`
    color: #222;
    font-size: 20px;
    font-weight: 550;
    padding-left: 30px;
    padding-right: 30px;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
`

const HorizontalSprator = styled.div`
    background-color: #58AC65;
    height: 1px;
`

export default UserProgram;